import React from 'react';
import { useTheme } from '../../hooks/useTheme';

/**
 * ThemeToggle — przełącznik motywu (dark / light) w nagłówku.
 * Pokazuje ikonę przeciwną do aktualnego motywu (kliknij aby przełączyć).
 */
const ThemeToggle = ({ compact = false }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const label = isDark ? 'Tryb jasny' : 'Tryb ciemny';

  return (
    <button
      type="button"
      data-testid="theme-toggle"
      onClick={toggleTheme}
      title={`Przełącz na ${label.toLowerCase()}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: compact ? '0' : '6px',
        padding: compact ? '8px' : '8px 12px',
        background: 'rgba(212, 175, 55, 0.15)',
        border: '1px solid var(--gold)',
        borderRadius: '8px',
        color: 'var(--gold)',
        cursor: 'pointer',
        fontSize: '13px',
        fontWeight: '700',
        transition: 'transform 0.18s ease, background 0.18s ease',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.05)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; }}
    >
      <span style={{ fontSize: '15px' }}>{isDark ? '☀️' : '🌙'}</span>
      {!compact && <span>{label}</span>}
    </button>
  );
};

export default ThemeToggle;
